import HouseSelectorView from './HouseSelectorViewContainer';
export default HouseSelectorView;
